import { Inject, Injectable, LOCALE_ID } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    private SUPPORTED_LANGUAGES = ['en', 'fr', 'nl', 'it'];
    constructor(
        @Inject(LOCALE_ID) private language
    ) {}

    getLanguage(defaultLanguage = 'en') {
        return this.SUPPORTED_LANGUAGES.includes(this.language) ? this.language : defaultLanguage;
    }
}
